var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoPreview",staticClass:"video-preview",style:({
    'background-image': ("url('" + _vm.image + "')")
  })},[_c('img',{staticClass:"video-preview__image",attrs:{"src":_vm.image,"alt":""}}),_c('div',{staticClass:"video-preview__time-label"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }